module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_000.png
// module id = 923
// module chunks = 0